<script setup lang="ts">
const { breadcrumbs } = useBreadcrumbs();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
</script>
<template>
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <div class="container">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <NuxtLink :to="formatLink(`/`)" class="">
            <div class="w-5 h-5 i-carbon-home mr-2" />
            {{ $t("home") }}
          </NuxtLink>
          <div class="w-5 h-5 i-carbon-chevron-right" />
        </li>
        <li v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb.path" class="breadcrumb-item">
          <NuxtLink v-if="breadcrumb.path" :to="formatLink(breadcrumb.path)">
            {{ breadcrumb.name }}
          </NuxtLink>
          <span v-else>{{ breadcrumb.name }}</span>
          <div v-if="index < breadcrumbs.length - 1" class="w-5 h-5 i-carbon-chevron-right" />
        </li>
      </ol>
    </div>
  </nav>
</template>
